export const statusStyles = (status) => {
    if (status === "Active") {
      return { color: "#14B8A6", backgroundColor: "#CCFBF1" };
    } else if (status === "Being Onboarded") {
      return { color: "#3B82F6", backgroundColor: "#DBEAFE" };
    } else if (status === "Waitlist") {
      return { color: "#F59E0B", backgroundColor: "#FEF3C7" };
    } else if (status === "Taking a Break") {
      return { color: "#D946EF", backgroundColor: "#FAE8FF" };
    } else if (status === "Summer Break") {
      return { color: "orange", backgroundColor: "#FEEBC8" };
    } else if (status === "Follow Up") {
      return { color: "red" };
    } else if (status === "Scholarship") {
      return { color: "red" };
    } else if (status === "Needs New Teacher") {
      return { color: "red" };
    } else if (status === "Left the School") {
      return { color: "#EF4444", backgroundColor: "#FEE2E2" };
    } else if (status === "Left For Now") {
      return { color: "#EF4444", backgroundColor: "#FEE2E2" };
    } else if (status === "Left - Permanently") {
      return { color: "#EF4444", backgroundColor: "#FEE2E2" };
    } else if (status === "Inquired") {
      return { color: "#EF4444", backgroundColor: "#FEE2E2" };
    } else if (status === "Out of Range") {
      return { color: "#EF4444", backgroundColor: "#FEE2E2" };
    } else {
      return { color: "black" };
    }
}
  
export const statusOptions = [
  {id: "Active", label: "Active" },
  {id: "Active", label: "Active"},
  {id: "Being Onboarded", label: "Being Onboarded"},
  {id: "Waitlist", label: "Waitlist"},
  {id: "Taking a Break", label: "Taking a Break"},
  {id: "Summer Break", label: "Summer Break"},
  {id: "Follow Up", label: "Follow Up"},
  {id: "Scholarship", label: "Scholarship"},
  {id: "Needs New Teacher", label: "Needs New Teacher"},
  {id: "Left the School", label: "Left the School"},
  {id: "Left For Now", label: "Left For Now"},
  {id: "Left Permanently", label: "Left - Permanently"},
  {id: "Inquired", label: "Inquired"},
  {id: "Out of Range", label: "Out of Range"},
]